export default class PasswordValidationSettings {
    constructor (json) {
        this.length = { enabled: false, passed: true };
        this.upperChars = { enabled: false, passed: true };
        this.lowerChars = { enabled: false, passed: true };
        this.numbers = { enabled: false, passed: true };
        this.special = { enabled: false, passed: true };
        this.alpha = { enabled: false, passed: true };
        this.maxConsecutiveChars = { enabled: false, passed: true };

        if (json)
            mapJsonToSettings(json, this);
    }
    toJson () {
        var json = {};
        mapJsonToSettings(this, json);
        return json;
    }
}

const mapJsonToSettings = (json, settings) => {
    if (json.MinimumPasswordLength > 0) {
        settings.length.enabled = true;
        settings.length.passed = false;
        settings.length.digits = json.MinimumPasswordLength;
    }
    if (json.RequiredCapitalLetters > 0) {
        settings.upperChars.enabled = true;
        settings.upperChars.passed = false;
        settings.upperChars.digits = json.RequiredCapitalLetters;
    }
    if (json.RequiredLowercaseLetters > 0) {
        settings.lowerChars.enabled = true;
        settings.lowerChars.passed = false;
        settings.lowerChars.digits = json.RequiredLowercaseLetters;
    }
    if (json.RequiredNumerals > 0) {
        settings.numbers.enabled = true;
        settings.numbers.passed = false;
        settings.numbers.digits = json.RequiredNumerals;
    }
    if (json.RequiredPunctuationOrOther > 0) {
        settings.special.enabled = true;
        settings.special.passed = false;
        settings.special.digits = json.RequiredPunctuationOrOther;
    }
    if (json.RequiredAlphabeticalLetters > 0) {
        settings.alpha.enabled = true;
        settings.alpha.passed = false;
        settings.alpha.digits = json.RequiredAlphabeticalLetters;
    }
    if (json.MaximumConsecutiveUserDataCharacters > 0) {
        settings.maxConsecutiveChars.enabled = true;
        settings.maxConsecutiveChars.passed = true;
        settings.maxConsecutiveChars.digits = json.MaximumConsecutiveUserDataCharacters;
    }
};

export const mapVirtualUserSecurityPolicyToSettings = (json) => {

    var settings = new PasswordValidationSettings();

    settings.length.enabled = true;
    settings.length.passed = false;
    settings.length.digits = json.MinimumPasswordLength;

    settings.upperChars.enabled = true;
    settings.upperChars.passed = false;
    settings.upperChars.digits = json.RequiredUppercaseLetters;

    settings.lowerChars.enabled = true;
    settings.lowerChars.passed = false;
    settings.lowerChars.digits = json.RequiredLowercaseLetters;

    settings.numbers.enabled = true;
    settings.numbers.passed = false;
    settings.numbers.digits = json.RequiredNumbers;

    settings.special.enabled = true;
    settings.special.passed = false;
    settings.special.digits = json.RequiredSpecialCharacters;

    settings.alpha.enabled = false;
    settings.alpha.passed = true;

    settings.maxConsecutiveChars.enabled = true;
    settings.maxConsecutiveChars.passed = true;
    settings.maxConsecutiveChars.digits = json.MaximumConsecutiveUserDataCharacters;

    return settings;
};
